import axios from "axios";
import { encodeBody, encodeQueryParams } from "./client";
import { baseUrl } from "./config";

// get apis
export const getCompanyDetails = (params:any) => {
    return axios({
      url: `${baseUrl}/api/datacapture/1/club/${params.clubId}${encodeQueryParams({
        isPast: params.isPast,
      })}`,
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    }).then(response => response.data.data);
  };
  
export const getContactDetails = (params:any) => {
    return axios({
      url: `${baseUrl}/api/datacapture/2/club/${params.clubId}${encodeQueryParams({
        isPast: params.isPast,
      })}`,
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    }).then(response => response.data.data);
  };
  
export const getStaffDetails = (params:any) => {
    return axios({
      url: `${baseUrl}/api/datacapture/5/club/${params.clubId}${encodeQueryParams({
        isPast: params.isPast,
      })}`,
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    }).then(response => response.data.data);
  };
  
export const getFacilitiesDetails = (params:any) => {
    return axios({
      url: `${baseUrl}/api/datacapture/6/club/${params.clubId}${encodeQueryParams({
        isPast: params.isPast,
      })}`,
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    }).then(response => response.data.data);
  };
  
export const getTeamDetails = (params:any) => {
    return axios({
      url: `${baseUrl}/api/datacapture/7/club/${params.clubId}${encodeQueryParams({
        isPast: params.isPast,
      })}`,
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    }).then(response => response.data.data);
  };
  
export const getProfitandLoss = (params:any) => {
    return axios({
      url: `${baseUrl}/api/datacapture/3/club/${params.clubId}${encodeQueryParams({
        isPast: params.isPast,
      })}`,
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    }).then(response => response.data.data);
  };

  
export const getSupportFund = (params:any) => {
    return axios({
      url: `${baseUrl}/api/datacapture/4/club/${params.clubId}${encodeQueryParams({
        isPast: params.isPast,
      })}`,
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    }).then(response => response.data.data);
  };
  
export const getPlayersDetails = (params:any) => {
    return axios({
      url: `${baseUrl}/api/datacapture/8/club/${params.clubId}${encodeQueryParams({
        isPast: params.isPast,
      })}`,
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    }).then(response => response.data.data);
  };

  //post apis

  export const saveCompanyDetails: any = (params:any) => {
    return axios({
      url: `${baseUrl}/api/datacapture/1/club/${params.clubId}`,
      method: 'POST',
      data: encodeBody(params.data),
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    }).then(response => response.data.data);
};

  export const saveContactDetails: any = (params:any) => {
    return axios({
      url: `${baseUrl}/api/datacapture/2/club/${params.clubId}`,
      method: 'POST',
      data: encodeBody(params.data),
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    }).then(response => response.data.data);
};

  export const saveStaffDetails: any = (params:any) => {
      return axios({
        url: `${baseUrl}/api/datacapture/5/club/${params.clubId}`,
        method: 'PUT',
        data: encodeBody(params.data),
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
      }).then(response => response.data.data);
  };
  
  export const saveTeamDetails: any = (params:any) => {
      return axios({
        url: `${baseUrl}/api/datacapture/7/club/${params.clubId}`,
        method: 'PUT',
        data: encodeBody(params.data),
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
      }).then(response => response.data.data);
  };
  
  export const saveProfitAndLoss: any = (params:any) => {
      return axios({
        url: `${baseUrl}/api/datacapture/3/club/${params.clubId}`,
        method: 'POST',
        data: encodeBody(params.data),
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
      }).then(response => response.data.data);
  };
  
  export const saveSupportFund: any = (params:any) => {
      return axios({
        url: `${baseUrl}/api/datacapture/4/club/${params.clubId}`,
        method: 'POST',
        data: encodeBody(params.data),
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
      }).then(response => response.data.data);
  };
  
  export const saveFacilities: any = (params:any) => {
      return axios({
        url: `${baseUrl}/api/datacapture/6/club/${params.clubId}`,
        method: 'PUT',
        data: encodeBody(params.data),
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
      }).then(response => response.data.data);
  };
  
  export const savePlayers: any = (params:any) => {
      return axios({
        url: `${baseUrl}/api/datacapture/8/club/${params.clubId}`,
        method: 'PUT',
        data: encodeBody(params.data),
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
      }).then(response => response.data.data);
  };

//delete apis

export const deleteProfitAndLoss: any = ({ clubId, id }:any) => {
  return axios({
    url: `${baseUrl}/api/datacapture/3/club/${clubId}/id/${id}`,
    method: 'DELETE',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  }).then(response => response.data.data);
};

export const deleteSupportFund: any = ({ clubId, id }:any) => {
  return axios({
    url: `${baseUrl}/api/datacapture/4/club/${clubId}/delete/${id}`,
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  }).then(response => response.data.data);
};

export const deleteStaff: any = ({ clubId, id }: any) => {
  return axios({
    url: `${baseUrl}/api/datacapture/5/club/${clubId}/id/${id}`,
    method: 'DELETE',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  }).then(response => response.data.data);
};

export const deleteFacility: any = ({ clubId, id }: any) => {
  return axios({
    url: `${baseUrl}/api/datacapture/6/club/${clubId}/id/${id}`,
    method: 'DELETE',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  }).then(response => response.data.data);
};

export const deleteGround: any = ({ clubId, id }: any) => {
  return axios({
    url: `${baseUrl}/api/datacapture/6/club/${clubId}/ground/${id}`,
    method: 'DELETE',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  }).then(response => response.data.data);
};

export const deleteTeam: any = ({ clubId, id }: any) => {
  return axios({
    url: `${baseUrl}/api/datacapture/7/club/${clubId}/id/${id}`,
    method: 'DELETE',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  }).then(response => response.data.data);
};

export const deletePlayer: any = ({ clubId, id }: any) => {
  return axios({
    url: `${baseUrl}/api/datacapture/8/club/${clubId}/id/${id}`,
    method: 'DELETE',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  }).then(response => response.data.data);
};

export const deleteAcademyPeriod: any = ({ clubId, id }: any) => {
  return axios({
    url: `${baseUrl}/api/datacapture/8/club/${clubId}/academy-period/${id}`,
    method: 'DELETE',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  }).then(response => response.data.data);
};

export const deleteClubCareer: any = ({ clubId, id }: any) => {
  return axios({
    url: `${baseUrl}/api/datacapture/8/club/${clubId}/club-career/${id}`,
    method: 'DELETE',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  }).then(response => response.data.data);
};

export const deleteInternationalCareer: any = ({ clubId, id }: any) => {
  return axios({
    url: `${baseUrl}/api/datacapture/8/club/${clubId}/international-career/${id}`,
    method: 'DELETE',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  }).then(response => response.data.data);
};

export const deleteCompetition: any = ({ id }: any) => {
  return axios({
    url: `${baseUrl}/api/datacapture/7/competition/${id}`,
    method: 'DELETE',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  }).then(response => response.data.data);
};

export const deleteTitle: any = ({ id }: any) => {
  return axios({
    url: `${baseUrl}/api/datacapture/7/title/${id}`,
    method: 'DELETE',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  }).then(response => response.data.data);
};